module.exports = __webpack_public_path__ + "media/application/images/ui/menu-tile-active-85b4f8d0d762c818018fc9c96abff559.svg";